import { useEffect } from "react";
import { useLocation } from "wouter";

// Resets scroll on route change; also sweeps likely scroll containers since
// which element actually scrolls varies with the page's layout structure.
export const useScrollToTop = (): void => {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    const scrollableElements = document.querySelectorAll(
      '[style*="overflow-y"]',
    );
    scrollableElements.forEach((element) => {
      if (element instanceof HTMLElement) {
        element.scrollTop = 0;
      }
    });

    // Checks only likely containers, not a full-tree querySelectorAll('*').
    requestAnimationFrame(() => {
      const scrollContainerSelectors = [
        "[data-scroll-container]",
        "main",
        '[role="main"]',
        ".scroll-container",
        "#root",
        "#app",
      ];
      const candidateElements = document.querySelectorAll(
        scrollContainerSelectors.join(","),
      );
      candidateElements.forEach((element) => {
        if (element instanceof HTMLElement) {
          const computedStyle = globalThis.window.getComputedStyle(element);
          const overflowY = computedStyle.overflowY;
          if (overflowY === "auto" || overflowY === "scroll") {
            element.scrollTop = 0;
          }
        }
      });
    });
  }, [location]);
};
